import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import CollapseButton from '../../components/Filter/CollapseButton';
import FilterPanel from '../../components/Filter/FilterPanel';
import { messages } from '../Filter/Filter.i18n';
import { toggleFilterPanel, medicalNotesFilterOptionsChanged }
  from '../../redux/modules/medical-notes/medical-notes-action-creator';
import { getDefaultFilter } from '../../redux/modules/medical-notes/medical-notes-reducer';
import { messages as medicalNoteMessages } from './MedicalNotes.i18n';
import { dateButtonGroupConfig,
  authorDropdownConfig,
  typeDropdownConfig,
} from './MedicalNotesFilterConfig';

class MedicalNotesFilters extends Component {
  constructor() {
    super();
    this.handleCollapseEvent = this.handleCollapseEvent.bind(this);
  }

  handleCollapseEvent() {
    this.props.dispatch(toggleFilterPanel(!this.props.showFilterPanel));
  }

  render() {
    const { formatMessage } = this.props.intl;
    const filterValues = [
      {
        id: 'type-filter',
        ref: 'documentTypefilter',
        list: typeDropdownConfig(this.props, this.props.filterDocuments, formatMessage),
        label: medicalNoteMessages.filter.documentType,
        xsSize: 12,
        smSize: 6,
        mdSize: 3,
      },
      {
        id: 'authored-by-filter',
        ref: 'authoredbyfilter',
        list: authorDropdownConfig(this.props, this.props.filterAuthors, formatMessage),
        label: medicalNoteMessages.filter.authoredBy,
        xsSize: 12,
        smSize: 6,
        mdSize: 3,
      },
    ];
    const dateValues = dateButtonGroupConfig(this.props, formatMessage);

    // Show empty space if the store does not have any initial state values.
    // if (!this.props.filterOptions) {
    //   return null;
    // }

    let messageElement = null;
    if (this.props.filter.date !== 'All' ||
        this.props.filter.documentType.length !== 0 ||
        this.props.filter.authoredBy.length !== 0) {
      messageElement = (<FormattedMessage
        { ...messages.filter.filterMessage }
        values={{
          filteredRows: this.props.filteredRows || '0',
          allRows: this.props.allRows || '0',
          rowItemName: <span className="d-none d-sm-inline">&nbsp;{
            formatMessage(medicalNoteMessages.filter.medicalnotes)
          }
                       </span>,
        }}
      />);
    }

    return (
      <div>
        <CollapseButton isOpen={this.props.showFilterPanel}
          onClick={this.handleCollapseEvent}
          variant="outline-secondary mb-2"
          icon="fa-solid fa-filter mr-1"
        />
        <div className="collapse-button-info small">
        { messageElement }
        </div>
        <FilterPanel isOpen={this.props.showFilterPanel}
          createFilterChangeAction={medicalNotesFilterOptionsChanged}
          filterValues={filterValues}
          dateValues={dateValues}
          filter={this.props.filter}
          keyDateFilterPreference="PatientPortal_MedicalNotesFilter_Date"
          clearFilter={getDefaultFilter()}
        />
      </div>
    );
  }
}

MedicalNotesFilters.propTypes = {
  dispatch: PropTypes.func,
  filter: PropTypes.object,
  intl: PropTypes.object,
  showFilterPanel: PropTypes.bool,
  filteredRows: PropTypes.number,
  allRows: PropTypes.number,
  allResults: PropTypes.array,
  filterDocuments: PropTypes.array,
  filterAuthors: PropTypes.array,
};

const mapStateToProps = (state) => ({
  filter: state.medicalNotes.filter,
  showFilterPanel: state.medicalNotes.showFilterPanel,
});

export default connect(mapStateToProps)(injectIntl(MedicalNotesFilters));